import { telaSobDemanda, type TelaRotina } from '../tipoTelaRotina';

export const telasCOM: Record<string, TelaRotina> = {
  'com/painel': telaSobDemanda(() => import('../../../modulos/COM/PainelCompras'), 'PainelCompras'),
  'com/encerramento': telaSobDemanda(() => import('../../../modulos/COM/PaginaEncerramento'), 'PaginaEncerramento'),
};

/** Ações extras na lista genérica (`acoesListaRotina`). */
export const acoesListaCOM: Record<string, TelaRotina> = {
  COM070: telaSobDemanda(() => import('../../../modulos/COM/ImportarXml'), 'BotaoImportarXml'),
};
